const ACTION_TYPES = {
    SET_COMPARE_MODE: 'SET_COMPARE_MODE',
    SET_SELECTED_PRODUCTS: 'SET_SELECTED_PRODUCTS',
    SET_COMPARISON_DATA: 'SET_COMPARISON_DATA',
    SET_COMPARISON_ERROR: 'SET_COMPARISON_ERROR'
};

const initialState = {
    isCompareModeEnabled: false,
    selectedProducts: [],
    comparisonData: null,
    comparisonError: null
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_COMPARE_MODE:
            return {
                ...state,
                isCompareModeEnabled: action.payload,
                // Clear products when disabling compare mode
                selectedProducts: action.payload ? state.selectedProducts : []
            };

        case ACTION_TYPES.SET_SELECTED_PRODUCTS:
            return {
                ...state,
                selectedProducts: action.payload
            };

        case ACTION_TYPES.SET_COMPARISON_DATA:
            return {
                ...state,
                comparisonData: action.payload,
                comparisonError: null
            };

        case ACTION_TYPES.SET_COMPARISON_ERROR:
            return {
                ...state,
                comparisonError: action.payload
            };

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
